/* The three stages as a curriculum, rather than as the homepage's walk down
 * the timeline: what is taught, to how many, by whom. `dotClass` colours the
 * stage marker the same way the homepage eyebrows are coloured. */
export const curriculum = [
  {
    id: 'toddler-room',
    eyebrow: 'Stage one',
    eyebrowClass: 'text-coral',
    dotClass: 'bg-coral',
    title: 'The Toddler Room',
    meta: 'Ages 2–4 · 12 children · 2 teachers',
    body: 'Days run on rhythm rather than timetable: singing, water play, story circle, a real nap, and outdoor time whatever the weather.',
    items: [
      'Early language & song',
      'Messy play and fine motor work',
      'Potty-training support',
      'Daily photo diary for parents',
      'Hot lunch and a real nap',
    ],
  },
  {
    id: 'primary',
    eyebrow: 'Stage two',
    eyebrowClass: 'text-forest',
    dotClass: 'bg-forest',
    title: 'Primary School',
    meta: 'Grades 1–5 · 18 per class',
    body: 'Reading, numbers and curiosity, taught in small groups by ability rather than age. Every child reads aloud to an adult daily.',
    items: [
      'English and mathematics daily',
      'Yoruba and one second language',
      'Science through experiment, not copying',
      'Music, art and PE every week',
      'Friday afternoon: a project of their own',
    ],
  },
  {
    id: 'secondary',
    eyebrow: 'Stage three',
    eyebrowClass: 'text-sun-deep',
    dotClass: 'bg-sun',
    title: 'Secondary School',
    meta: 'Grades 6–10 · subject teachers',
    body: 'Serious subject teaching without losing the warmth. A named mentor follows each student from Grade 6 to graduation.',
    items: [
      'Physics, chemistry, biology in real labs',
      'Mathematics and further mathematics',
      'Literature, history and civics',
      'Workshop: woodwork, electronics, coding',
      'Exam preparation from Grade 8',
    ],
  },
];

/** Deliberately a real Tuesday rather than a brochure timetable. */
export const primaryDay = [
  { time: '7:50', what: 'Gate opens, breakfast club, free reading' },
  { time: '8:30', what: 'Mathematics in three ability groups' },
  { time: '10:00', what: 'Break outdoors — 25 minutes, always' },
  { time: '10:25', what: 'One-to-one reading with Ms. Grace' },
  { time: '12:15', what: 'Hot lunch, mixed-age tables' },
  { time: '13:30', what: 'Science, then music or art' },
];
